// Unpublished Work © 2023 Deere & Company

import t from 'tcomb';

export const CrossReferenceDetail = t.struct({
    sourceSystemId: t.String,
    sourceSystemDescription: t.String,
    sourceSystemCustomerNumber: t.String,
    entityId: t.Number,
    contactId: t.Number,
    communicationLocatorId: t.Number,
    lastModified: t.String,
    sourceSystemUnitId: t.String
}, {
    defaultProps: {
        sourceSystemId: '',
        sourceSystemDescription: '',
        sourceSystemCustomerNumber: '',
        entityId: 0,
        contactId: 0,
        communicationLocatorId: 0,
        lastModified: '',
        sourceSystemUnitId: ''
    },
    name: 'CrossReferenceDetail',
    strict: true
});
